"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Druid_1 = require("../../Druid");
const Objects_1 = require("../../Utility/Objects");
const Selectors_1 = require("../../Utility/Selectors");
function assignElementData(element, name, data) {
    // setting element.files in test is quite challenging, only some heavy js magic seems to work. Too difficult to maintain at the moment.
    // jsdom FileList: https://github.com/jsdom/jsdom/issues/1272
    /* istanbul ignore if */
    if (element.type === 'file') {
        if (element.files !== null && element.files.length > 0) {
            for (const file of Array.from(element.files)) {
                data = Objects_1.default.assign(data, name, file);
            }
        }
    }
    else if (element.type === 'select-multiple') {
        // append all options of multi select
        element.querySelectorAll('option[selected]').forEach((option) => {
            data = Objects_1.default.assign(data, name, option.value.trim());
        });
    }
    else if ((element.type !== 'checkbox' && element.type !== 'radio') || element.checked) {
        // append any input/textarea/select or checked checkbox,radio
        data = Objects_1.default.assign(data, name, element.value.trim());
    }
    return data;
}
// eslint-disable-next-line max-lines-per-function
(() => {
    HTMLElement.prototype.getFormData = function getFormData(role, options) {
        var _a, _b;
        let data = {};
        // add data role selector if necessary
        const dataRole = (_a = Selectors_1.default.createDataRoleSelector(role)) !== null && _a !== void 0 ? _a : '';
        const prefix = (_b = options === null || options === void 0 ? void 0 : options.selectorPrefix) !== null && _b !== void 0 ? _b : '';
        const selector = Druid_1.default.configuration().form.elements.map((val) => prefix + val + dataRole).join(',');
        // find all input elements within the form
        this.querySelectorAll(selector).forEach((element) => {
            const name = element.getAttribute('name');
            // is nameless
            if (name === null || name.trim() === '') {
                return;
            }
            // exclude disabled elements, if configured
            if (element.disabled && (options === null || options === void 0 ? void 0 : options.includeDisabled) !== true) {
                return;
            }
            data = assignElementData(element, name, data);
        });
        return data;
    };
})();
//# sourceMappingURL=GetFormData.js.map